import React, { useState, useEffect } from "react";
import { ToastMain, SweetAlertShow, LoadingDiv } from "../../../master/Master";
import { useLocation, useNavigate } from "react-router-dom";
import { getSessions } from "../../../../api/SessionsService";
import { courseList } from "../../../../api/Courses";
import { getBatchList } from "../../../../api/BatchService";
import TestLayout from "../TestLayout";
import Header from "../../../master/SideBar";
import Nav from "../../../master/NavBar";
import { testAdd } from "../../../../api/TestServiceV2";
import { getTestSeriesList } from "../../../../api/TestService";

const AddNewTest = () => {
  const [loading, setLoading] = useState(false);
  const [courses, setCourses] = useState([]);
  const [batch, setBatch] = useState([]);
  const location = useLocation();

  const [selectedSubjectIds, setSelectedSubjectIds] = useState([]);
  const [marksList, setMarksList] = useState({});

  const [selectedCourseId, setSelectedCourseId] = useState("");
  const [selectedSubjects, setSelectedSubjects] = useState([]);

  const [typeTest, setTypeTest] = useState("");
  const [totalMarks, setTotalMarks] = useState(0);

  const [Data, setData] = useState([]);
  const [error, setError] = useState("");

  const [selectedSession, setSelectedSession] = useState("");

  const [subjectDetails, setSubjectDetails] = useState([]);
  const [scheduleData, setScheduleData] = useState([]);

  const [combinedSchedule, setCombinedSchedule] = useState({
    date: "",
    start_time: "",
    end_time: "",
  });

  const navigate = useNavigate();

  const [enableTimeTable, setEnableTimeTable] = useState(false);

  const [selectedBatches, setSelectedBatches] = useState([]);

  const [isCreatingTest, setIsCreatingTest] = useState(false);

  const [examMode, setExamMode] = useState("normal");
  const [combinedMarks, setCombinedMarks] = useState("");
  const [resultType, setResultType] = useState("numerical");

  useEffect(() => {
    const filtered = selectedSubjects
      .filter((sub) => selectedSubjectIds.includes(sub.id))
      .map((sub) => ({
        subject_name: sub.name,
        subject_id: sub.id,
        date: "",
        start_time: "",
        end_time: "",
      }));

    setSubjectDetails(filtered);
    setScheduleData(filtered);
  }, [selectedSubjectIds, selectedSubjects]);

  const handleScheduleChange = (index, field, value) => {
    const updated = [...scheduleData];
    updated[index][field] = value;
    setScheduleData(updated);
  };

  const handleCombinedScheduleChange = (field, value) => {
    setCombinedSchedule((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const getSession = async () => {
    setLoading(true);

    try {
      const response = await getSessions();

      if (response?.data?.status) {
        const activeSession = response?.data?.data?.find(
          (s) => s.status === "1",
        );

        if (activeSession) {
          setSelectedSession(activeSession.id);
        }
      } else {
        SweetAlertShow("info", "Warning", response?.data?.message);
      }
    } catch (error) {
      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.message ?? error?.message,
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getSession();
  }, []);

  const handleCheckboxChange = (subjectId) => {
    setSelectedSubjectIds((prevSelected) =>
      prevSelected.includes(subjectId)
        ? prevSelected.filter((id) => id !== subjectId)
        : [...prevSelected, subjectId],
    );
  };

  const handleBatchToggle = (batchId) => {
    setSelectedBatches((prev) =>
      prev.includes(batchId)
        ? prev.filter((id) => id !== batchId)
        : [...prev, batchId],
    );
  };

  const handleBatchSelectAll = () => {
    setSelectedBatches(batch.map((b) => b.id));
  };

  const handleBatchClearAll = () => {
    setSelectedBatches([]);
  };

  useEffect(() => {
    const selectedCourse = courses.find(
      (course) => course.id === parseInt(selectedCourseId),
    );

    if (selectedCourse) {
      setSelectedSubjects(selectedCourse.subjects_list);
    } else {
      setSelectedSubjects([]);
    }
  }, [selectedCourseId, courses]);

  const handleMarksChange = (subjectId, value) => {
    setMarksList((prev) => ({
      ...prev,
      [subjectId]: value,
    }));
  };

  useEffect(() => {
    if (examMode === "combined") {
      setSelectedSubjectIds([]);
      setMarksList({});
      setSubjectDetails([]);
      setScheduleData([]);
    } else {
      setCombinedMarks("");
      setCombinedSchedule({
        date: "",
        start_time: "",
        end_time: "",
      });
    }
  }, [examMode]);

  useEffect(() => {
    if (examMode === "combined") {
      setTotalMarks(Number(combinedMarks) || 0);
    } else {
      const total = Object.values(marksList).reduce(
        (sum, m) => sum + (Number(m) || 0),
        0,
      );

      setTotalMarks(total);
    }
  }, [marksList, combinedMarks, examMode]);

  const createTest = async (e) => {
    e.preventDefault();

    // Prevent duplicate submissions
    if (isCreatingTest) return;

    setIsCreatingTest(true);
    setError("");

    try {
      const formData = new FormData(e.currentTarget);

      formData.append("exam_mode", examMode);
      formData.append("combined_marks", combinedMarks);

      if (enableTimeTable) {
        if (examMode === "combined") {
          const singleSchedule = [
            {
              subject_id: null,
              subject_name: "Combined Exam",
              date: combinedSchedule.date,
              start_time: combinedSchedule.start_time,
              end_time: combinedSchedule.end_time,
            },
          ];

          formData.append("subject_schedule", JSON.stringify(singleSchedule));
        } else {
          const subjectSchedule = scheduleData.map((item) => ({
            subject_id: item.subject_id,
            subject_name: item.subject_name,
            date: item.date,
            start_time: item.start_time,
            end_time: item.end_time,
          }));

          formData.append("subject_schedule", JSON.stringify(subjectSchedule));
        }
      }

      const response = await testAdd(formData);

      if (response?.data?.status) {
        ToastMain.fire({
          icon: "success",
          title: "Created Successfully!",
        }).then(() => {
          navigate("/tests/view");
        });
      } else {
        if (response?.data?.errors) {
          setError(response.data.errors);
        }

        SweetAlertShow("info", "Warning", response?.data?.message);
      }
    } catch (error) {
      if (error?.response?.data?.errors) {
        setError(error.response.data.errors);
      }

      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.message ??
          error?.response?.message ??
          error?.message,
      );
    } finally {
      setIsCreatingTest(false);
    }
  };

  const courseFetch = async () => {
    setLoading(true);

    try {
      const response = await courseList();

      if (response.data.status) {
        setCourses(response.data.data);
      } else {
        SweetAlertShow("info", "Warning", response?.data?.message);
      }
    } catch (error) {
      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.message ?? error?.message,
      );
    } finally {
      setLoading(false);
    }
  };

  const batchFetch = async (id) => {
    setLoading(true);

    const addUrl = `&session_id=${selectedSession}&course_id=${id}`;

    try {
      const response = await getBatchList(addUrl);

      if (response.data && response.data.data) {
        setBatch(response.data.data);
        setSelectedBatches([]);
      } else {
        SweetAlertShow("info", "Warning", response?.data?.message);
      }
    } catch (error) {
      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.message ?? error?.message,
      );
    } finally {
      setLoading(false);
    }
  };

  const fetchSeriesList = async () => {
    setLoading(true);

    try {
      const response = await getTestSeriesList();

      if (response.data.status) {
        setData(response.data.data);
      }
    } catch (error) {
      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.message ?? error?.message,
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    courseFetch();
    fetchSeriesList();
  }, []);

  const hasErrors = error && Object.keys(error).length > 0;

  return (
    <>
      {loading && <LoadingDiv />}

      <div className="layout-wrapper layout-content-navbar">
        <div className="layout-container">
          <Header />

          <div className="layout-page">
            <Nav />

            <div className="content-wrapper">
              <div className="container-fluid py-3">
                <div className="row">
                  <TestLayout />

                  <div className="col-12">
                    {/* =====================================================
                        SIMPLE PAGE HEADER
                    ====================================================== */}
                    <div className="card border-0 shadow-sm mb-4">
                      <div className="card-body p-4">
                        <div className="d-flex align-items-center justify-content-between flex-wrap gap-3">
                          <div className="d-flex align-items-center">
                            <div
                              className="bg-label-primary rounded-3 d-flex align-items-center justify-content-center me-3"
                              style={{
                                width: 48,
                                height: 48,
                                minWidth: 48,
                              }}
                            >
                              <i className="ri-add-line fs-3 text-primary"></i>
                            </div>

                            <div>
                              <h4 className="mb-1 fw-bold">Create New Test</h4>

                              <p className="text-muted mb-0">
                                Add test details, subjects, batches and marks.
                              </p>
                            </div>
                          </div>

                          <button
                            type="button"
                            className="btn btn-outline-secondary"
                            onClick={() => navigate(-1)}
                          >
                            <i className="ri-arrow-left-line me-1"></i>
                            Back
                          </button>
                        </div>
                      </div>
                    </div>

                    {/* =====================================================
                        FORM
                    ====================================================== */}
                    <div className="card border-0 shadow-sm">
                      <div className="card-body p-4">
                        {hasErrors && (
                          <div
                            className="alert alert-danger d-flex align-items-start mb-4"
                            role="alert"
                          >
                            <i className="ri-error-warning-line fs-5 me-2"></i>

                            <div>
                              <strong className="d-block mb-1">
                                Please check the following:
                              </strong>

                              <ul className="mb-0 ps-3">
                                {Object.entries(error).map(([key, msg]) => (
                                  <li key={key}>
                                    {Array.isArray(msg) ? msg[0] : msg}
                                  </li>
                                ))}
                              </ul>
                            </div>
                          </div>
                        )}

                        <form onSubmit={createTest}>
                          {/* =================================================
                              BASIC DETAILS
                          ================================================== */}
                          <div className="mb-4">
                            <div className="d-flex align-items-center mb-3">
                              <i className="ri-file-text-line text-primary fs-5 me-2"></i>

                              <div>
                                <h5 className="mb-0 fw-semibold">
                                  Test Details
                                </h5>

                                <small className="text-muted">
                                  Basic information about this test.
                                </small>
                              </div>
                            </div>

                            <div className="row g-3">
                              <div className="col-12">
                                <label className="form-label">
                                  Test Title
                                  <span className="text-danger ms-1">*</span>
                                </label>

                                <input
                                  type="text"
                                  className={`form-control input-capitalize ${
                                    error?.title ? "is-invalid" : ""
                                  }`}
                                  name="title"
                                  placeholder="Enter test title"
                                />

                                {error?.title && (
                                  <div className="text-danger small mt-1">
                                    {error.title}
                                  </div>
                                )}
                              </div>

                              <div className="col-md-4">
                                <label className="form-label">
                                  Test Type
                                  <span className="text-danger ms-1">*</span>
                                </label>

                                <select
                                  name="test_type"
                                  className={`form-select ${
                                    error?.test_type ? "is-invalid" : ""
                                  }`}
                                  value={typeTest}
                                  onChange={(e) => setTypeTest(e.target.value)}
                                >
                                  <option value="">Select Test Type</option>

                                  <option value="series">Test Series</option>

                                  <option value="notseries">
                                    Without Series
                                  </option>
                                </select>

                                {error?.test_type && (
                                  <div className="text-danger small mt-1">
                                    {error.test_type}
                                  </div>
                                )}
                              </div>

                              {typeTest === "series" && (
                                <div className="col-md-4">
                                  <label className="form-label">
                                    Test Series
                                  </label>

                                  <select
                                    name="parent_id"
                                    className="form-select"
                                  >
                                    <option value="">Select Test Series</option>

                                    {Data?.data?.map((item) => (
                                      <option key={item.id} value={item.id}>
                                        {item.title}
                                      </option>
                                    ))}
                                  </select>
                                </div>
                              )}

                              <div
                                className={
                                  typeTest === "series"
                                    ? "col-md-4"
                                    : "col-md-8"
                                }
                              >
                                <label className="form-label">Exam Date</label>

                                <input
                                  type="date"
                                  className="form-control"
                                  name="date"
                                />
                              </div>
                            </div>
                          </div>

                          <hr className="my-4" />

                          {/* =================================================
                              COURSE & BATCH
                          ================================================== */}
                          <div className="mb-4">
                            <div className="d-flex align-items-center mb-3">
                              <i className="ri-group-line text-primary fs-5 me-2"></i>

                              <div>
                                <h5 className="mb-0 fw-semibold">
                                  Course & Batches
                                </h5>

                                <small className="text-muted">
                                  Select the course and batches for this test.
                                </small>
                              </div>
                            </div>

                            <div className="row g-3">
                              <div className="col-md-6">
                                <label className="form-label">
                                  Course
                                  <span className="text-danger ms-1">*</span>
                                </label>

                                <select
                                  name="course_id"
                                  className={`form-select ${
                                    error?.course_id ? "is-invalid" : ""
                                  }`}
                                  value={selectedCourseId}
                                  onChange={(e) => {
                                    setSelectedCourseId(e.target.value);
                                    batchFetch(e.target.value);
                                  }}
                                >
                                  <option value="">Select Course</option>

                                  {courses?.map((course) => (
                                    <option key={course.id} value={course.id}>
                                      {course.title}
                                    </option>
                                  ))}
                                </select>

                                {error?.course_id && (
                                  <div className="text-danger small mt-1">
                                    {error.course_id}
                                  </div>
                                )}
                              </div>

                              <div className="col-md-6">
                                <div className="d-flex justify-content-between align-items-center mb-2">
                                  <label className="form-label mb-0">
                                    Batches
                                  </label>

                                  {batch?.length > 0 && (
                                    <div className="d-flex gap-2">
                                      <button
                                        type="button"
                                        className="btn btn-sm btn-link p-0"
                                        onClick={handleBatchSelectAll}
                                      >
                                        Select All
                                      </button>

                                      <button
                                        type="button"
                                        className="btn btn-sm btn-link text-muted p-0"
                                        onClick={handleBatchClearAll}
                                      >
                                        Clear
                                      </button>
                                    </div>
                                  )}
                                </div>

                                <div
                                  className="border rounded-2 p-3"
                                  style={{
                                    maxHeight: "180px",
                                    overflowY: "auto",
                                  }}
                                >
                                  {batch?.length === 0 ? (
                                    <div className="text-center py-3 text-muted">
                                      <i className="ri-group-line fs-4 d-block mb-1"></i>

                                      <small>
                                        {selectedCourseId
                                          ? "No batches found."
                                          : "Select a course first."}
                                      </small>
                                    </div>
                                  ) : (
                                    batch.map((item) => (
                                      <div
                                        className="form-check mb-2"
                                        key={item.id}
                                      >
                                        <input
                                          className="form-check-input"
                                          type="checkbox"
                                          id={`batch_${item.id}`}
                                          name="batch_id[]"
                                          value={item.id}
                                          checked={selectedBatches.includes(
                                            item.id,
                                          )}
                                          onChange={() =>
                                            handleBatchToggle(item.id)
                                          }
                                        />

                                        <label
                                          htmlFor={`batch_${item.id}`}
                                          className="form-check-label"
                                          style={{ cursor: "pointer" }}
                                        >
                                          {item.title}
                                        </label>
                                      </div>
                                    ))
                                  )}
                                </div>

                                {batch?.length > 0 && (
                                  <small className="text-muted">
                                    {selectedBatches.length} of {batch.length}{" "}
                                    selected
                                  </small>
                                )}

                                {error?.batch_id && (
                                  <div className="text-danger small mt-1">
                                    {error.batch_id}
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>

                          <hr className="my-4" />

                          {/* =================================================
                              MARKS CONFIGURATION
                          ================================================== */}
                          <div className="mb-4">
                            <div className="d-flex align-items-center mb-3">
                              <i className="ri-award-line text-primary fs-5 me-2"></i>

                              <div>
                                <h5 className="mb-0 fw-semibold">
                                  Marks & Result
                                </h5>

                                <small className="text-muted">
                                  Configure how marks will be calculated.
                                </small>
                              </div>
                            </div>

                            <div className="row g-3">
                              <div className="col-md-4">
                                <label className="form-label">Exam Mode</label>

                                <select
                                  name="exam_mode"
                                  className="form-select"
                                  value={examMode}
                                  onChange={(e) => setExamMode(e.target.value)}
                                >
                                  <option value="normal">Normal Test</option>

                                  <option value="combined">
                                    Combined Test
                                  </option>
                                </select>
                              </div>

                              {examMode === "combined" && (
                                <div className="col-md-4">
                                  <label className="form-label">
                                    Combined Total Marks
                                  </label>

                                  <input
                                    type="number"
                                    className="form-control"
                                    name="combined_marks"
                                    value={combinedMarks}
                                    onChange={(e) =>
                                      setCombinedMarks(e.target.value)
                                    }
                                    placeholder="Enter total marks"
                                  />
                                </div>
                              )}

                              <div className="col-md-4">
                                <label className="form-label">
                                  Result Type
                                </label>

                                <select
                                  name="result_type"
                                  className="form-select"
                                  value={resultType}
                                  onChange={(e) =>
                                    setResultType(e.target.value)
                                  }
                                >
                                  <option value="numerical">Numerical</option>

                                  <option value="grading">Grading</option>
                                </select>
                              </div>
                            </div>
                          </div>

                          {/* =================================================
                              SUBJECTS
                          ================================================== */}
                          {examMode === "normal" && (
                            <>
                              <hr className="my-4" />

                              <div className="mb-4">
                                <div className="d-flex justify-content-between align-items-center mb-3">
                                  <div className="d-flex align-items-center">
                                    <i className="ri-book-open-line text-primary fs-5 me-2"></i>

                                    <div>
                                      <h5 className="mb-0 fw-semibold">
                                        Subjects
                                      </h5>

                                      <small className="text-muted">
                                        Select subjects and enter their marks.
                                      </small>
                                    </div>
                                  </div>

                                  <span className="badge bg-label-primary">
                                    {selectedSubjectIds.length} Selected
                                  </span>
                                </div>

                                {!selectedCourseId ? (
                                  <div className="text-center border rounded-2 py-5 text-muted">
                                    <i className="ri-book-open-line fs-2 d-block mb-2"></i>

                                    <div>Select a course to view subjects.</div>
                                  </div>
                                ) : selectedSubjects?.length === 0 ? (
                                  <div className="text-center border rounded-2 py-4 text-muted">
                                    No subjects available for this course.
                                  </div>
                                ) : (
                                  <div className="row g-3">
                                    {selectedSubjects?.map((subject) => {
                                      const isSelected =
                                        selectedSubjectIds.includes(subject.id);

                                      return (
                                        <div
                                          className="col-xl-3 col-lg-4 col-md-6"
                                          key={subject.id}
                                        >
                                          <div
                                            className={`border rounded-2 p-3 h-100 ${
                                              isSelected
                                                ? "border-primary bg-label-primary"
                                                : ""
                                            }`}
                                          >
                                            <div className="d-flex align-items-center">
                                              <input
                                                type="checkbox"
                                                className="form-check-input me-2"
                                                id={`subject_${subject.id}`}
                                                name="subjects[]"
                                                value={subject.id}
                                                checked={isSelected}
                                                onChange={() =>
                                                  handleCheckboxChange(
                                                    subject.id,
                                                  )
                                                }
                                              />

                                              <label
                                                htmlFor={`subject_${subject.id}`}
                                                className="fw-medium mb-0"
                                                style={{ cursor: "pointer" }}
                                              >
                                                {subject.name}
                                              </label>
                                            </div>

                                            {isSelected && (
                                              <div className="mt-3">
                                                <label className="form-label small">
                                                  Marks
                                                </label>

                                                <input
                                                  type="number"
                                                  className="form-control form-control-sm"
                                                  name="subjects_marks[]"
                                                  placeholder="Enter marks"
                                                  value={
                                                    marksList[subject.id] || ""
                                                  }
                                                  onChange={(e) =>
                                                    handleMarksChange(
                                                      subject.id,
                                                      e.target.value,
                                                    )
                                                  }
                                                />
                                              </div>
                                            )}
                                          </div>
                                        </div>
                                      );
                                    })}
                                  </div>
                                )}
                              </div>
                            </>
                          )}

                          {/* =================================================
                              TIMETABLE
                          ================================================== */}
                          <hr className="my-4" />

                          <div className="mb-4">
                            <div className="d-flex justify-content-between align-items-center flex-wrap gap-2">
                              <div className="d-flex align-items-center">
                                <i className="ri-calendar-line text-primary fs-5 me-2"></i>

                                <div>
                                  <h5 className="mb-0 fw-semibold">
                                    {examMode === "combined"
                                      ? "Exam Timetable"
                                      : "Subject Timetable"}
                                  </h5>

                                  <small className="text-muted">Optional</small>
                                </div>
                              </div>

                              <button
                                type="button"
                                className={`btn btn-sm ${
                                  enableTimeTable
                                    ? "btn-outline-danger"
                                    : "btn-outline-primary"
                                }`}
                                onClick={() =>
                                  setEnableTimeTable(!enableTimeTable)
                                }
                              >
                                <i
                                  className={`${
                                    enableTimeTable
                                      ? "ri-close-line"
                                      : "ri-calendar-line"
                                  } me-1`}
                                ></i>

                                {enableTimeTable
                                  ? "Remove Timetable"
                                  : "Add Timetable"}
                              </button>
                            </div>

                            {enableTimeTable && (
                              <div className="mt-3">
                                {examMode === "combined" ? (
                                  <div className="table-responsive border rounded-2">
                                    <table className="table table-bordered align-middle mb-0">
                                      <thead>
                                        <tr>
                                          <th>Exam</th>
                                          <th>Date</th>
                                          <th>Start Time</th>
                                          <th>End Time</th>
                                        </tr>
                                      </thead>

                                      <tbody>
                                        <tr>
                                          <td className="fw-medium">
                                            Combined Exam
                                          </td>

                                          <td>
                                            <input
                                              type="date"
                                              className="form-control"
                                              value={combinedSchedule.date}
                                              onChange={(e) =>
                                                handleCombinedScheduleChange(
                                                  "date",
                                                  e.target.value,
                                                )
                                              }
                                            />
                                          </td>

                                          <td>
                                            <input
                                              type="time"
                                              className="form-control"
                                              value={
                                                combinedSchedule.start_time
                                              }
                                              onChange={(e) =>
                                                handleCombinedScheduleChange(
                                                  "start_time",
                                                  e.target.value,
                                                )
                                              }
                                            />
                                          </td>

                                          <td>
                                            <input
                                              type="time"
                                              className="form-control"
                                              value={combinedSchedule.end_time}
                                              onChange={(e) =>
                                                handleCombinedScheduleChange(
                                                  "end_time",
                                                  e.target.value,
                                                )
                                              }
                                            />
                                          </td>
                                        </tr>
                                      </tbody>
                                    </table>
                                  </div>
                                ) : subjectDetails.length === 0 ? (
                                  <div className="border rounded-2 text-center py-4 text-muted">
                                    <i className="ri-calendar-line fs-3 d-block mb-2"></i>
                                    Select subjects to create their timetable.
                                  </div>
                                ) : (
                                  <div className="table-responsive border rounded-2">
                                    <table className="table table-bordered align-middle mb-0">
                                      <thead>
                                        <tr>
                                          <th>Subject</th>
                                          <th>Date</th>
                                          <th>Start Time</th>
                                          <th>End Time</th>
                                        </tr>
                                      </thead>

                                      <tbody>
                                        {subjectDetails.map((item, index) => (
                                          <tr key={item.subject_id}>
                                            <td className="fw-medium">
                                              {item.subject_name}
                                            </td>

                                            <td>
                                              <input
                                                type="date"
                                                className="form-control"
                                                value={
                                                  scheduleData[index]?.date ||
                                                  ""
                                                }
                                                onChange={(e) =>
                                                  handleScheduleChange(
                                                    index,
                                                    "date",
                                                    e.target.value,
                                                  )
                                                }
                                              />
                                            </td>

                                            <td>
                                              <input
                                                type="time"
                                                className="form-control"
                                                value={
                                                  scheduleData[index]
                                                    ?.start_time || ""
                                                }
                                                onChange={(e) =>
                                                  handleScheduleChange(
                                                    index,
                                                    "start_time",
                                                    e.target.value,
                                                  )
                                                }
                                              />
                                            </td>

                                            <td>
                                              <input
                                                type="time"
                                                className="form-control"
                                                value={
                                                  scheduleData[index]
                                                    ?.end_time || ""
                                                }
                                                onChange={(e) =>
                                                  handleScheduleChange(
                                                    index,
                                                    "end_time",
                                                    e.target.value,
                                                  )
                                                }
                                              />
                                            </td>
                                          </tr>
                                        ))}
                                      </tbody>
                                    </table>
                                  </div>
                                )}
                              </div>
                            )}
                          </div>

                          {/* =================================================
                              TOTAL + SUBMIT
                          ================================================== */}
                          <div className="border-top pt-4 mt-4">
                            <div className="row align-items-end">
                              <div className="col-md-4 mb-3 mb-md-0">
                                <label className="form-label">
                                  Total Marks
                                </label>

                                <input
                                  type="number"
                                  className="form-control fw-bold"
                                  name="total_marks"
                                  value={totalMarks}
                                  readOnly
                                />

                                <small className="text-muted">
                                  {examMode === "normal"
                                    ? "Calculated from subject marks."
                                    : "Calculated from combined marks."}
                                </small>
                              </div>

                              <div className="col-md-8">
                                <div className="d-flex justify-content-end gap-2">
                                  <button
                                    className="btn btn-primary px-4"
                                    disabled={isCreatingTest}
                                    type="submit"
                                  >
                                    {isCreatingTest ? (
                                      <>
                                        <span
                                          className="spinner-border spinner-border-sm me-2"
                                          role="status"
                                          aria-hidden="true"
                                        />
                                        Creating Test...
                                      </>
                                    ) : (
                                      <>
                                        <i className="ri-check-line me-1" />
                                        Create Test
                                      </>
                                    )}
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddNewTest;
